import Vue from 'vue'
import dayjs from 'dayjs'
require('dayjs/locale/fr')
var relativeTime = require('dayjs/plugin/relativeTime')
// Object.defineProperties(Vue.prototype, {
//     $date: {
//         get() {
//             return dayjs
//         }
//     }
// });
dayjs.locale('fr')
dayjs.extend(relativeTime)
Object.defineProperty(Vue.prototype, '$date', { value: dayjs })
